"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PREVIEW_DIALOG_BACK_BUTTON = exports.SEARCH_PREVIEW_DIALOG = void 0;
const SEARCH_PREVIEW_DIALOG = exports.SEARCH_PREVIEW_DIALOG = 'search-preview-dialog';
const SEARCH_PREVIEW_DIALOG_BACK_BUTTON = exports.SEARCH_PREVIEW_DIALOG_BACK_BUTTON = 'search-preview-dialog-back-button';
